import script from "./BasicInfoPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./BasicInfoPanel.vue?vue&type=script&setup=true&lang=js"

import "./BasicInfoPanel.vue?vue&type=style&index=0&id=223d10ba&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-223d10ba"]])

export default __exports__